import { render, staticRenderFns } from "./ComparePanDetailsDialog.vue?vue&type=template&id=74868a40&scoped=true"
import script from "./ComparePanDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ComparePanDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./ComparePanDetailsDialog.vue?vue&type=style&index=0&id=74868a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74868a40",
  null
  
)

export default component.exports